var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_5397)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72 2.495a1 1 0 011.226-.708l9.222 2.472a1 1 0 01.707 1.224l-3.83 14.293a1 1 0 01-1.224.707l-.019-.005V5.154a1 1 0 00-1-1H9.277l.444-1.658zM3.27 6.203a1 1 0 011-1h9.548a1 1 0 011 1V21a1 1 0 01-1 1H4.27a1 1 0 01-1-1V6.203zm7.058 5.583c-.784-.824-1.283-1.334-1.283-1.334s-.5.51-1.283 1.334c-.413.434-1.342 1.512-1.342 2.584 0 .715.55 1.294 1.23 1.294.445 0 .834-.25 1.05-.624a.127.127 0 01.097-.05c.063 0 .12.047.114.105-.048.385-.254 1.335-1.067 1.656h2.4c-.812-.32-1.019-1.27-1.066-1.656-.007-.058.051-.105.114-.105.04 0 .075.023.097.05.214.374.604.624 1.05.624.679 0 1.23-.58 1.23-1.294 0-1.072-.93-2.15-1.342-2.584z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_5397"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgPokerFilled.displayName = 'PokerFilled';
export default SvgPokerFilled;